// import { AppConfigService } from '../../../core/app.config.service';
import { Component, ElementRef, Input, OnInit, OnDestroy,TemplateRef, ViewChild } from '@angular/core';
import { GameService } from '../../../../shared/services/game/game.service';
import {
    AddressCombined,
    GameMessageType,
    GameModalMessage,
    PrizeDetail,
    GameDetails
} from '../../../../shared/constants/divisional.interface';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { GAMETYPES, PRIZETYPES } from '../../../../shared/constants/constants';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'prize-details',
    templateUrl: './prize-details.component.html'
})

export class PrizeDetailsComponent implements OnInit, OnDestroy {

    public gameId: string = '';
    public prizeId: string = '';
    public prizeType: string = '';
    public sm = '575px';
    public md = '768px';
    private imagePath: string;
    public isDisabled: boolean = true;
    public showDetails: boolean = false;
    public prize: PrizeDetail = null;
    public availablePoints: number = 0;
    public userOptedIn: boolean = false;
    public codes: string[] = null;
    public programName: string = null;
    public loading: boolean = true;
    public noGameCode : boolean = false;
    public programType: string = null;
    public GAMETYPES = GAMETYPES;
    public tokenLabelSingular: string = '';
    public tokenLabelPlural: string = '';
    public banner: string = '';
    private currentEnvironment: string;
    private destroy$ = new Subject<void>();
    @Input() userInfo: any;

    @ViewChild('errorPopup', { read: TemplateRef }) errorPopup: TemplateRef<any>;
    public errorPopupRef: BsModalRef = null;

    public constructor(private route: ActivatedRoute, public gameService: GameService, public modalService: BsModalService, private authService: AuthService) {
        
    }

    ngOnInit(): void {
        this.currentEnvironment = this.gameService.getEnvironment();
        this.imagePath = environment[this.currentEnvironment].imagePath;
        this.banner = this.userInfo && this.userInfo.banner;
        this.route.paramMap.subscribe(params => {
            this.gameId = params.get('game');
            this.prizeId = params.get('prize');
            const [prizeType, extension] = params.get('type')?.split('.');
            this.prizeType =prizeType;
        });
        this.gameService.getCustomerType(this.userInfo).subscribe(
            (response: AddressCombined) => {
                this.userInfo.userType = response.customerType ? response.customerType : 'C';
                this.getGamesInfo();
            },(error) => {
                this.userInfo.userType = 'C'
                this.getGamesInfo();
        });
        this.gameService.refreshOptInStatusOnlyObservable.pipe(takeUntil(this.destroy$)).subscribe((data) => {
            if(data) {
                this.userOptedIn = true;
                if(data.prizeDetail.prizeId == this.prize.prizeId) {
                    setTimeout(() => {
                        this.redeemPrize(data.elementEvent);
                    }, 0);
                }
            }
        });
        
    }

    public getGamesInfo() {
        this.gameService.getPrograms(this.gameId, this.userInfo).subscribe((res: any) => {
            this.codes = this.gameService.getProgramCodes(res || []);
            if (this.codes.length) {
                this.userOptedIn = false;

                if (res?.storePrograms[0]?.optInStatus) {
                    this.userOptedIn = res.storePrograms[0].optInStatus
                }

                if (res?.storePrograms[0]?.name) {
                    this.programName = res.storePrograms[0].name
                }

                if (res?.storePrograms[0]?.type) {
                    this.programType = res.storePrograms[0].type
                }

                if (res?.storePrograms[0].tokenLabelSingular) {
                    this.tokenLabelSingular = res.storePrograms[0].tokenLabelSingular
                }

                if (res?.storePrograms[0].tokenLabelPlural) {
                    this.tokenLabelPlural = res.storePrograms[0].tokenLabelPlural
                }
                const storeProgram = res.storePrograms[0];
                let programFAQLink, programRulesLink, disclaimer, programMinAge;
                if (storeProgram.faqurl) {
                    programFAQLink = storeProgram.faqurl;
                }
                if (storeProgram.rulesurl) {
                    programRulesLink = storeProgram.rulesurl;
                }
                if (storeProgram.disclaimer) {
                    disclaimer = storeProgram.disclaimer;

                     // fix up links in data from database
                     disclaimer = disclaimer.replace(/{faqLink}/g,`<a target='_blank' class='links__action links__action__inline underline' href='${programFAQLink}'>${programFAQLink}</a>`);
                     disclaimer = disclaimer.replace(/{rulesLink}/g,`<a target='_blank' class='links__action links__action__inline underline' href='${programRulesLink}'>${programRulesLink}</a>`);
                     disclaimer = disclaimer.replace(/{banner}/g,this.banner);
                }
                if(storeProgram.minAge) {
                    programMinAge = storeProgram.minAge;
                }
                let details: GameDetails = {
                    codes: this.codes.join(','),
                    names: this.programName,
                    type: this.programType,
                    userOptedIn: this.userOptedIn,
                    disclaimer: disclaimer,
                    tokenLabelSingular: this.tokenLabelSingular,
                    tokenLabelPlural: this.tokenLabelPlural,
                    programMinAge: programMinAge
                }
                this.gameService.refreshGameDetails.next(details);

                this.getPrizeDetails();

            } else if(this.codes.length == 0) {
                this.loading = false;
                this.noGameCode = true;
                this.showDetails = true;
            }
        }, (error) => {
            this.loading = false;
            this.errorPopupRef = this.modalService.show(this.errorPopup, { class: 'episodic-modal-dialog' });
        });

    }

    public getPrizeDetails() {
        this.gameService.getPrizeDetails(this.prizeId, this.prizeType, this.gameId, this.userInfo).subscribe(response => {
            this.prize = response;
            
            let heading = document.querySelector("H1.hidden-title");
            if (heading && this.prize && this.prize.name) {
                heading.innerHTML = this.prize.name + " details";
            }

            if (!this.prize.hasOwnProperty("availableCount")) {
                this.prize.availableCount = 1;
            }
            localStorage.setItem('selectedPrize', this.prize.prizeId);

            if (this.isProgramDivision()) {
                this.gameService.getProgramPoints([this.gameId], this.userInfo).subscribe((response) => {
                    this.availablePoints = response?.programPoints[0]?.totalGamePoints || 0;
                    this.isDisabled = this.isProgram_AvailablePointsPrizeBurnPoints();
                    this.loading = false;
                    this.showDetails = true;
                }, (error) => {
                    this.loading = false;
                    this.errorPopupRef = this.modalService.show(this.errorPopup, { class: 'episodic-modal-dialog' });
                });
            } else {
                this.loading = false;
                this.showDetails = true;
                this.isDisabled = true;
            }

        }, (error) => {
            this.loading = false;
            this.errorPopupRef = this.modalService.show(this.errorPopup, { class: 'episodic-modal-dialog' });
        });
    }

    public isProgram_AvailablePointsPrizeBurnPoints(): boolean {
        if(this.gameService.optinEnhancements &&  (this.availablePoints >= this.prize.burnPoints)) {
            return false;
          } else {
            return ((this.availablePoints < this.prize.burnPoints) || !this.userOptedIn)
          }
    }

    public isProgramDivision(): boolean {
        return (this.gameService.isAuthenticated(this.userInfo) && this.programType === GAMETYPES.DIVISION)
    }

    public getImageUrl(prize: PrizeDetail, viewport: string): string {
        let id = prize.prizeId;
        if (prize.type == PRIZETYPES.B4U_OFFER && prize.imageId) {
            id = prize.imageId;
        }
        const modifiedImagePath = this.imagePath;
        return modifiedImagePath ? modifiedImagePath.replace('${product.id}', id).replace('${viewport}', viewport) : '';
    }

    public userOptinFlow(event) {
        let message: GameModalMessage = {
          mode: GameMessageType.SHOWOPTINFROMPRIZE,
          prizeDetail: this.prize,
          gameId: this.gameId || "",
          userInfo: this.userInfo,
          elementEvent: event
        };
        this.gameService.gameModalMessage.next(message);
      }

    public redeemPrize(event=null) {

        if (!this.isDisabled) {
            if(this.gameService.optinEnhancements) {
                if((this.prize.type == PRIZETYPES.SWEEPSTAKES || this.prize.type == PRIZETYPES.VENDOR) && !this.userOptedIn) {
                  //Start OptinFlow.
                  this.userOptinFlow(event);
                  return;
                }
            }
            let message: GameModalMessage = {
                mode: GameMessageType.PRIZEREDEEM,
                prizeDetail: this.prize,
                gameId: this.gameId || '',
                userInfo: this.userInfo
            }

            this.gameService.gameModalMessage.next(message);
        }

    }

    public setImagePath(path: string): void {
        this.imagePath = path;
    }

    public getImagePath(): string {
        return this.imagePath;
    }

    public closeAndRefresh() {
        this.errorPopupRef.hide();
        window['location'].reload()
    }

    public ngOnDestroy(): void {
        this.destroy$.next();  // This will trigger the unsubscription
        this.destroy$.complete();
    }

}
